module.exports = __webpack_public_path__ + "static/img/2.784f87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/list/2.png
// module id = J7xa
// module chunks = 1